import React, { createContext, useEffect, useState } from 'react';

import { Networks, Onchain } from 'impermax-sdk';

import { useChainId, useNetworkName } from '../hooks/useNetwork';
import useOffchain from '../hooks/useOffchain';
import useWeb3 from '../hooks/useWeb3';

export interface OnchainContextI {
    onchainInstance?: Onchain;
    onchainUpdate?: number;
    doUpdate?: Function;
    priceInverted?: boolean;
    togglePriceInverted?: Function;
}

export const OnchainContext = createContext<OnchainContextI>({});

export const OnchainProvider = ({ children }) => {
    const network = useNetworkName() as Networks;
    const web3 = useWeb3();
    const chainId = useChainId();
    const offchain = useOffchain();
    const [onchainInstance, setOnchainInstance] = useState<Onchain>();
    const [onchainUpdate, setRouterUpdate] = useState<number>(0);
    const [priceInverted, setPriceInverted] = useState<boolean>(false);

    const doUpdate = () => {
        if (!onchainInstance) return;
        onchainInstance.cleanCache();
        onchainInstance.getOffchain().cleanCache();
        setRouterUpdate(onchainUpdate + 1);
    };
    const togglePriceInverted = () => {
        if (!onchainInstance) return;
        onchainInstance.setPriceInverted(!priceInverted);
        setPriceInverted(!priceInverted);
    };

    useEffect(() => {
        // togliendo unlockWallet serve un setWeb3 nel onchain?
        if (web3 && !onchainInstance) {
            const onchainInstance = new Onchain({
                network,
                offchain,
                web3,
                chainId,
                priceInverted,
            });
            setOnchainInstance(onchainInstance);
        }
    }, [web3]);

    return (
        <OnchainContext.Provider
            value={{
                onchainInstance,
                onchainUpdate,
                doUpdate,
                priceInverted,
                togglePriceInverted,
            }}
        >
            {children}
        </OnchainContext.Provider>
    );
};
